// lib/recovery.ts — Premium BIP39-style 12-word mnemonic recovery phrase utility

const wordList = [
  "about", "above", "action", "actor", "acute", "admit", "adopt", "advice", "agent", "agree",
  "album", "alert", "alike", "alive", "allow", "alone", "along", "alpha", "alter", "anger",
  "angle", "angry", "apart", "apple", "apply", "arena", "argue", "arise", "armor", "arrow",
  "aside", "asset", "audio", "audit", "avoid", "award", "aware", "bacon", "badge", "baker",
  "basic", "basis", "basket", "beach", "beard", "beauty", "begin", "being", "below", "bench",
  "berry", "bible", "bingo", "birdie", "birth", "biscuit", "bitter", "black", "blade", "blame",
  "blank", "blast", "blend", "blind", "blink", "block", "blonde", "blood", "bloom", "board",
  "boast", "bonus", "boost", "booth", "border", "brain", "brand", "brass", "brave", "bread",
  "break", "brick", "bride", "brief", "bright", "bring", "brisk", "broad", "bronze", "brown",
  "brush", "bubble", "bucket", "buddy", "budget", "build", "bullet", "bunch", "burger", "burst"
];

/** Generate a premium 12-word mnemonic recovery code */
export function generateRecoveryCode(): string {
  const words: string[] = [];
  for (let i = 0; i < 12; i++) {
    const idx = Math.floor(Math.random() * wordList.length);
    words.push(wordList[idx]);
  }
  return words.join(" ");
}
